import UIUXImaage from "@/assets/images/uiux/ui-ux-intro.webp";
import { Paintbrush, MousePointer2, LayoutDashboard, Users } from "lucide-react";

const CHIPS = [
	{ icon: <Paintbrush size={13} strokeWidth={1.8} />, label: "Intuitive Design" },
	{ icon: <MousePointer2 size={13} strokeWidth={1.8} />, label: "Seamless UX" },
	{ icon: <LayoutDashboard size={13} strokeWidth={1.8} />, label: "User-Centered" },
	{ icon: <Users size={13} strokeWidth={1.8} />, label: "Brand Connection" },
];

export default function IntroSection() {
	return (
		<section className="relative py-16 md:py-24 overflow-hidden">

			{/* ── Ambient glow ── */}
			<div
				className="absolute top-1/2 right-0 -translate-y-1/2 w-[500px] h-[500px] rounded-full pointer-events-none"
				style={{ background: "radial-gradient(circle, rgba(99,102,241,0.07) 0%, transparent 70%)" }}
			/>
			<div
				className="absolute top-1/4 left-0 w-[400px] h-[400px] rounded-full pointer-events-none"
				style={{ background: "radial-gradient(circle, rgba(6,182,212,0.06) 0%, transparent 70%)" }}
			/>

			<div className="container">
				<div className="grid lg:grid-cols-2 gap-10 lg:gap-20 items-center">

					{/* ── Image LEFT ── */}
					<div className="relative">
						<div
							className="overflow-hidden rounded-2xl h-[320px] md:h-[400px] lg:h-[460px]"
							style={{ boxShadow: "0 32px 64px rgba(0,0,0,0.6)" }}
						>
							<img
								src={UIUXImaage}
								alt="UI/UX Design"
								className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
							/>
							<div
								className="absolute bottom-0 left-0 right-0 h-24 pointer-events-none"
								style={{ background: "linear-gradient(to top, rgba(0,0,0,0.55), transparent)" }}
							/>
						</div>

						{/* Badge */}
						<div
							className="absolute -bottom-5 -right-4 md:right-6 rounded-2xl px-5 py-4 text-center border"
							style={{
								backgroundColor: "#0d0d0d",
								borderColor: "rgba(255,255,255,0.08)",
								boxShadow: "0 16px 40px rgba(0,0,0,0.5)",
							}}
						>
							<p className="text-3xl font-bold leading-none bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 bg-clip-text text-transparent">
								100%
							</p>
							<p className="text-sm mt-1" style={{ color: "rgba(255,255,255,0.45)" }}>
								User Satisfaction
							</p>
						</div>

						{/* Floating badge — top left */}
						<div
							className="absolute top-4 left-4 rounded-xl px-4 py-3 border hidden sm:flex items-center gap-2.5"
							style={{
								backgroundColor: "#0d0d0d",
								borderColor: "rgba(6,182,212,0.2)",
								boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
							}}
						>
							<div
								className="w-12 h-12 rounded-lg flex items-center justify-center shrink-0"
								style={{ background: "rgba(6,182,212,0.12)", border: "1px solid rgba(6,182,212,0.2)" }}
							>
								<Paintbrush size={22} style={{ color: "#22d3ee" }} />
							</div>
							<div>
								<p className="text-white text-sm font-bold leading-none">UI/UX Design</p>
								<p className="text-sm mt-0.5" style={{ color: "rgba(255,255,255,0.35)" }}>
									Design · Delight · Deliver
								</p>
							</div>
						</div>
					</div>

					{/* ── Content RIGHT ── */}
					<div className="space-y-5 pt-6 lg:pt-0">

						{/* Title */}
						<div>
							<h2 className="text-3xl md:text-[2.6rem] font-bold text-white leading-snug">
								The Essence of
								<span className="bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 bg-clip-text text-transparent pl-2">
									UI/UX Design
								</span>
							</h2>
							<div className="w-12 h-0.5 rounded-full bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 mt-4" />
						</div>

						{/* Body */}
						<div
							className="space-y-4 text-base md:text-lg leading-relaxed"
							style={{ color: "rgba(255,255,255,0.65)" }}
						>
							<p>
								UI/UX design is crucial for shaping how users interact with digital products. By
								focusing on intuitive design and seamless functionality, we ensure that every
								interaction is meaningful and satisfying.
							</p>
							<p>
								At <span className="text-white font-semibold">SAN micron</span>, we prioritize
								user-centered design to help you create products that not only meet business goals
								but also delight users at every touchpoint — fostering a deeper connection between
								users and your brand.
							</p>
						</div>

						{/* Capability chips */}
						<div className="flex flex-wrap gap-2">
							{CHIPS.map(({ icon, label }) => (
								<span
									key={label}
									className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-semibold border transition-all duration-200 hover:border-white/20 cursor-default"
									style={{
										color: "rgba(255,255,255,0.5)",
										borderColor: "rgba(255,255,255,0.08)",
										background: "rgba(255,255,255,0.03)",
									}}
								>
									<span style={{ color: "#22d3ee" }}>{icon}</span>
									{label}
								</span>
							))}
						</div>
					</div>

				</div>
			</div>
		</section>
	);
}